export default [
  {
    name: 'ContactLinksEdit',
    path: 'settings/contact-links',
    component: () => import('pages/settings/contact-links/ContactLinksEdit.vue')
  }
]
